module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ./~/fetch-mock/~/isarray/index.js
// module id = 196
// module chunks = 0